import React, { useState } from "react";
import { Button, Form, Table } from "react-bootstrap";

import Select from "react-select";
import { toast } from "react-toastify";
import { CustomForm, CustomModal } from "../../components";
import {
  useCreateUniversitySportMutation,
  useFetchAllSportsQuery,
  useFetchAllUniversitySportsQuery,
  useFetchAthletesQuery,
  useFetchCollegesQuery,
} from "../../store/api/apiSlice";
import { Button as CustomBtn, Input } from "../../ui";

const UniversitySportsManagementPage = () => {
  const { data: sportsResponse = {} } = useFetchAllSportsQuery();
  const { data: athletesResponse = {} } = useFetchAthletesQuery();
  const { data: universitiesResponse = [] } = useFetchCollegesQuery();
  const {
    data: universitySportsResponse = { universitySports: [] },
    refetch: refetchUniversitySports,
  } = useFetchAllUniversitySportsQuery();

  const universitesData = universitySportsResponse.universitySports;
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [createUniversitySport] = useCreateUniversitySportMutation();
  const [saveButton, setSaveButton] = useState(false);

  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedSports, setSelectedSports] = useState([]);
  const [selectedAthletes, setSelectedAthletes] = useState([]);
  const [selectedUniversity, setSelectedUniversity] = useState(null);

  const openModal = () => setModalOpen(true);
  const closeModal = () => {
    setSaveButton(false);
    setModalOpen(false);
    setSelectedSports([]);
    setSelectedAthletes([]);
    setSelectedUniversity(null);
  };

  const handleCreateUniversitySport = async () => {
    setSaveButton(true);
    if (
      !selectedUniversity ||
      selectedSports.length === 0 ||
      selectedAthletes.length === 0
    ) {
      setSaveButton(false);
      toast.error(
        "Please select a university, at least one sport, and one athlete."
      );
      return;
    }

    const universitySportData = {
      universityID: selectedUniversity.value,
      sportsID: selectedSports.map((sport) => sport.value),
      athleteIDs: selectedAthletes.map((athlete) => athlete.value),
    };

    try {
      await createUniversitySport(universitySportData).unwrap();
      setSaveButton(false);
      toast.success("University sport with athletes added successfully!");
      refetchUniversitySports();
      closeModal();
    } catch (error) {
      setSaveButton(false);
      toast.error("Error creating university sport:", error.message || error);
    }
  };

  const sportsOptions = Array.isArray(sportsResponse.sports)
    ? sportsResponse.sports.map((sport) => ({
        value: sport._id,
        label: sport.name,
      }))
    : [];

  const athletesOptions = Array.isArray(athletesResponse.athletes)
    ? athletesResponse.athletes.map((athlete) => ({
        value: athlete._id,
        label: `${athlete.firstName} ${athlete.lastName}`,
      }))
    : [];

  const universityOptions = (universitiesResponse.university || []).map(
    (university) => ({
      value: university._id,
      label: university.name,
    })
  );
  const paginatedUsers = universitesData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(universitesData.length / itemsPerPage);

  return (
    <div className="container mt-4">
      <h3>University Sports Management</h3>
      <div className="universityManagement_AdSport">
        <Button variant="primary" onClick={openModal} className="mb-3">
          Add Sports & Athletes
        </Button>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Sport Name</th>
            <th>Athletes</th>
            <th>University</th>
          </tr>
        </thead>
        <tbody>
          {paginatedUsers.length ? (
            paginatedUsers.map((us) => (
              <tr key={us._id}>
                <td>{us?.sportsID?.name}</td>
                <td>
                  {us.athleteIDs
                    .map(
                      (athlete) => `${athlete.firstName} ${athlete.lastName}`
                    )
                    .join(", ")}
                </td>
                <td>
                  {us.universityID ? us?.universityID?.name : "Not Assigned"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-center">
                No sports and athletes added for this university.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <div className="d-flex justify-content-center mt-3">
        {Array.from({ length: totalPages }, (_, index) => (
          <Button
            key={index}
            variant={currentPage === index + 1 ? "primary" : "outline-primary"}
            onClick={() => setCurrentPage(index + 1)}
            className="mx-1"
          >
            {index + 1}
          </Button>
        ))}
      </div>

      <CustomModal
        isOpen={isModalOpen}
        onClose={closeModal}
        className="customModalWidth2"
      >
        <h3 className="modalHeading borderb">Add Sports and Athletes</h3>
        <div className="inviteForm">
          <CustomForm
            onSubmit={(e) => e.preventDefault()}
            className="col-10 mx-auto"
          >
            <div className="fieldWrapper col-12 mb-3">
              <Form.Label>University</Form.Label>
              <Select
                options={universityOptions}
                value={selectedUniversity}
                onChange={(selected) => setSelectedUniversity(selected)}
                placeholder="Select University"
              />
            </div>

            <div className="fieldWrapper col-12 mb-3">
              <Form.Label>Sports</Form.Label>
              <Select
                options={sportsOptions}
                isMulti
                value={selectedSports}
                onChange={(selected) => setSelectedSports(selected)}
                placeholder="Select Sports"
              />
            </div>

            <div className="fieldWrapper col-12 mb-3">
              <Form.Label>Athletes</Form.Label>
              <Select
                options={athletesOptions}
                isMulti
                value={selectedAthletes}
                onChange={(selected) => setSelectedAthletes(selected)}
                placeholder="Select Athletes"
              />
            </div>

            <div
              className="universityManagement_Cancel_btn"
            >
              <Button variant="secondary" onClick={closeModal}>
                Cancel
              </Button>
              <CustomBtn
                variant="primary"
                onClick={handleCreateUniversitySport}
                loading={saveButton}
              >
                Save
              </CustomBtn>
            </div>
          </CustomForm>
        </div>
      </CustomModal>
    </div>
  );
};

export default UniversitySportsManagementPage;
